import React from "react";
import ProjectLayout from "../ProjectLayout";
import "../ProjectPage.css";

export default function DreamPage() {
  return (
    <ProjectLayout
      title="Dream Machine XR"
      role="Unity Developer (C#) - VR (Quest 3, WebGL)"
      team="6"
      duration="6 Months"
      engine="Unity (C#) - WebGL - VR"
      about="Dream Machine is an interactive, multiplayer VR music experience that debuted at the Lincoln Centre in New York in July 2024."
      videoSrc={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/dreamVRFootage.mp4`}
      playLink={`https://www.dreammachinexr.com`}
      playText="Dream Machine Page"
      galleryImages={[
        `${process.env.PUBLIC_URL}/img/dream/1.webp`,
        `${process.env.PUBLIC_URL}/img/dream/2.webp`,
        `${process.env.PUBLIC_URL}/img/dream/3.mp4`,
        `${process.env.PUBLIC_URL}/img/dream/4.mp4`,
      ]}
    >
      <section>
        <h2>About</h2>
        <p>
          Developed on behalf of <a href="https://www.eyejack.io/">Eyejack</a>,
          Dream Machine is a time-travel, music-driven VR experience immersed in
          Afrofuturism. You explore bespoke artist environments and a virtual
          performance venue called The Crown.
        </p>
      </section>

      <section>
        <h2>What I Learned</h2>
        <p>
          Working with 2 other VR developers, this was my most complex and
          ambitious project yet. I learned about making VR interactions intuitive,
          optimizing shaders for Quest 3, and handling multiplayer synchronization
          across 40 simultaneous users.
        </p>
      </section>
    </ProjectLayout>
  );
}
